export const API = process.env.REACT_APP_API_URL || "/api";
export const EPA_API = `${API}/epa`;

export default API;
